@if (items?.length) {
  <ng-content select=".element-before-carousel"></ng-content>
  @switch (carouselLayout) {
    @case (CarouselLayout.FLAT) {
      <div id="{{carouselId}}" [ngStyle]="{'width' : carouselWidth}">
        <ul [ngClass]="key" class="list-unstyled p-0 m-0 row row-cols-{{itemsPerRow}}">
          @for (item of items; track item) {
            <li class="p-0" [ngClass]="{'col': itemsPerRow, 'col-auto': !itemsPerRow}">
              @if (template) {
                <div
                [innerHtml]="template | replaceTokensArray: {keys: item, previewVar: entityPreviewVar} | safe: 'html'"></div>
              }
            </li>
          }
        </ul>
      </div>
    }
    @default {
      <div class="position-relative"
        id="{{carouselId}}"
        [ngStyle]="{'width' : carouselWidth}"
        >
        @if (showPlayButton && intervalId) {
          <button class="btn-custom-preview-carousel-pause mx-3"
            style="position: absolute; left: 0; bottom: 0;"
            (click)="startPlay()"
            attr.aria-label="{{'Disable carousel auto play'|translate}}">
            <i class="material-icons align-middle">pause_circle_outline</i>
            <i class="fa fa-pause d-none" aria-pressed="false"></i>
          </button>
        }
        @if (showPlayButton && !intervalId) {
          <button class="btn-custom-preview-carousel-play mx-3"
            style="position: absolute; left: 0; bottom: 0;"
            (click)="startPlay()"
            attr.aria-label="{{'Enable carousel auto play'|translate}}">
            <i class="material-icons align-middle">play_circle_outline</i>
            <i class="fa fa-play d-none" aria-pressed="true"></i>
          </button>
        }
        <div class="d-flex align-items-baseline hide-scrollbar" style="width: auto; overflow: auto; scroll-behavior: smooth;" #altCarouselContainer>
          @for (item of items; track item) {
            <div
              class="flex-grow-0 flex-shrink-0"
                     [ngStyle]="{
                            'width' : carouselItemsWidth,
                            'margin-top': gridInfo['margin-top'],
                            'margin-bottom': gridInfo['margin-bottom'],
                            'margin-right': gridInfo['margin-right'],
                            'margin-left': gridInfo['margin-left']}">
              @if (template) {
                <div
                [innerHtml]="template | replaceTokensArray: {keys: item, previewVar: entityPreviewVar} | safe: 'html'"></div>
              }
            </div>
          }
        </div>
        @if (showCarouselButtons) {
          <i class="fas fa-chevron-left" (click)="scrollAltCarousel('left')" style="position: absolute; left: -30px; top: 50%; transform: translateY(-50%); cursor: pointer;"> </i>
          <i class="fas fa-chevron-right"  (click)="scrollAltCarousel('right')" style="position: absolute; right: -30px; top: 50%; transform: translateY(-50%); cursor: pointer;"> </i>
        }
      </div>
    }
  }
  <ng-content select=".element-after-carousel"></ng-content>
}

